// extracted by mini-css-extract-plugin
export var acitonButtons = "_m9-0";
export var additionalIcon = "_m9-f";
export var block = "_m9-1";
export var blockContent = "_m9-7";
export var blockDescription = "_m9-8";
export var blockIcon = "_m9-9";
export var blockTitle = "_m9-6";
export var border = "_m9-a";
export var center = "_m9-l";
export var edge = "_m9-b";
export var edgeLabel = "_m9-c";
export var edgePath = "_m9-d";
export var error = "_m9-e";
export var flowchart = "_m9-g";
export var flowchartContent = "_m9-h";
export var highlighted = "_m9-3";
export var hover = "_m9-4";
export var icon = "_m9-i";
export var left = "_m9-m";
export var navButton = "_m9-j";
export var navButtons = "_m9-k";
export var right = "_m9-n";
export var selected = "_m9-2";
export var small = "_m9-5";